import React from 'react';
import {Title} from './ProjectPortfolioPeriodTitle.styled';
import {useIntl} from 'react-intl';

export const ProjectPortfolioPeriodTitle = () => {
	const intl = useIntl();
	return <Title>{intl.formatMessage({id: 'reports.period_totals'})}</Title>;
};
